<template>
  <div :class="getClassName('parts-item')">
    <v-img
      :class="getClassName('parts-item__thumbnail')"
      :src="item.option.color.thumbnail"
      :alt="item.name"
      contain
      :width="media ? '54' : '78'"
      :height="media ? '46' : '74'"
    />
    <div :class="getClassName('parts-item__content')">
      <div :class="getClassName('parts-item__name')">{{ item.name }}・{{ item.option.color.name }}</div>
      <div :class="getClassName('parts-item__quantity')">
        <v-text-field
          :class="getClassName('parts-item__field')"
          type="number"
          min="1"
          v-model="internalValue"
          outlined
          hide-details
          dense
        />
        <span :class="getClassName('parts-item__unit')">{{ item.unit }}</span>
      </div>
    </div>
    <button :class="getClassName('parts-item__remove')" type="button" @click="removeParts(item)">削除</button>
  </div>
</template>

<script>
import getClassName from '../../_mixins/getClassName';

export default {
  mixins: [getClassName],
  props: {
    item: {
      type: Object,
      required: true,
      default: () => {},
    },
    value: {
      type: Object,
      required: true,
      default: () => {},
    },
    media: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  computed: {
    internalValue: {
      get() {
        return this.value.quantity;
      },
      set(newValue) {
        if (this.value.quantity !== newValue) this.$emit('input', { ...this.value, quantity: newValue });
      },
    },
  },
  methods: {
    removeParts(item) {
      this.$emit('remove-parts', item);
    },
  },
};
</script>

<style lang="scss">
.parts-item {
  &__field {
    .v-input__slot {
      min-height: 36px !important;
    }
    &--sp {
      .v-input__slot {
        min-height: 20px !important;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
@import '../../_sass/variables';

.parts-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  &:not(:first-child) {
    margin-top: 40px;
  }
  &--sp {
    &:not(:first-child) {
      margin-top: 20px;
    }
  }
  &__thumbnail {
    flex: 0 0 auto;
  }
  &__content {
    margin-left: 22px;
    flex: 1 1 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    &--sp {
      margin-left: 7px;
      font-size: 1rem;
      align-self: stretch;
      flex-flow: column nowrap;
      align-items: flex-start;
    }
  }
  &__name {
    &--sp {
      line-height: 1;
      flex: 1 0 auto;
      display: flex;
      flex-flow: column nowrap;
      justify-content: center;
    }
  }
  &__quantity {
    display: flex;
    align-items: center;
  }
  &__field {
    width: 80px;
    border-color: $color__line--item;
    border-radius: 0px;
    flex: 0 0 auto;
    &--sp {
      width: 50px;
    }
  }
  &__unit {
    margin-left: 0.5em;
  }
  &__remove {
    background: #b6b6b6;
    width: 65px;
    height: 24px;
    border-radius: 12px;
    margin-left: 28px;
    color: #fff;
    letter-spacing: 0.5em;
    text-indent: 0.5em;
    line-height: 1;
    flex: 0 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    &--sp {
      width: 53px;
      height: 18px;
      margin-left: auto;
      font-size: 1rem;
      align-self: flex-end;
    }
  }
}
</style>
